import { getApiUrl, getAuthToken, getHeaders, handleApiError } from './api-helpers'
import { getTenantHeader } from './api-interceptor'


export interface Tenant {
  id: string
  name: string
  slug?: string | null
  domain?: string | null
  settings?: Record<string, unknown>
  metadata?: {
    createdBy?: string
    status?: string
  }
  createdAt?: string | null
  updatedAt?: string | null
}

/**
 * Listar todos os tenants disponíveis
 */
export async function listTenants(): Promise<Tenant[]> {
  const apiUrl = getApiUrl()
  const token = await getAuthToken()
  const url = `${apiUrl}/tenants`
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      ...getTenantHeader(),
    },
  })
  if (!response.ok) {
    const errorText = await response.text()
    let error
    try {
      error = JSON.parse(errorText)
    } catch {
      error = { message: errorText || 'Erro desconhecido' }
    }
    throw new Error(error.message || error.error || 'Erro ao listar tenants')
  }

  const result = await response.json()
  return result.data || []
}

/**
 * Obter detalhes de um tenant
 */
export async function getTenant(tenantId: string): Promise<Tenant> {
  const apiUrl = getApiUrl()
  const token = await getAuthToken()
  const url = `${apiUrl}/tenants/${tenantId}`

  const response = await fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}`, 'X-Tenant-Id': tenantId },
  })
  if (!response.ok) await handleApiError(response, 'Erro ao buscar tenant')
  const result = await response.json()
  if (!result.success || !result.data) {
    throw new Error(result.message || 'Erro ao buscar tenant')
  }
  return result.data
}

/** De que grupo de envio a empresa faz parte (configurado pela Zavy); null = envio não ativo. */
export async function obterEnvioColaborador(
  tenantId: string,
): Promise<{ grupo: { nome: string; dominios: string[]; ativo: boolean } | null }> {
  const response = await fetch(`${getApiUrl()}/tenants/${tenantId}/envio-colaborador`, {
    headers: { ...(await getHeaders()), "Content-Type": "application/json" },
  });
  if (!response.ok) await handleApiError(response, "Erro ao carregar o envio pelo funcionário");
  return response.json();
}
